import { useCometState } from '#pplx/frontend/apps/ask/comet-browser/providers/EntropyBrowserHooks.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { parseUrl } from '#pplx/frontend/common/files/urls.js';
import { getWindowOrigin } from '#pplx/frontend/common/location.js';
import { useMemo } from 'react';
const PUBLIC_WEB_ORIGIN_FALLBACK = 'https://www.perplexity.ai';
const createUrl = (path) => {
    const origin = getWindowOrigin({ intent: 'public-web' }) || PUBLIC_WEB_ORIGIN_FALLBACK;
    const url = parseUrl(`${origin}${path}`);
    return url?.href || `${origin}${path}`;
};
const getAvailableDxts = () => [
    {
        id: 'imessage',
        icon_url: createUrl('/static/mcpb/imessage.png'),
        download_url: createUrl('/static/mcpb/imessage_v0.0.10.mcpb'),
        manifest: {
            $schema: 'https://static.modelcontextprotocol.io/schemas/2025-08-26/mcpb.manifest.schema.json',
            dxt_version: '0.1',
            name: 'imessage',
            display_name: 'Messages',
            version: '0.0.10',
            description: "Send and read messages using Apple's Messages app",
            long_description: "This tool lets Perplexity work with your Mac's Messages app. You can send messages, read messages, and ask Perplexity to help you understand what's important.\n\nIt uses Mac system features to connect to Messages. Your Mac will ask for permission before it can access Messages or Contacts. This is not made by Apple.",
            license: 'MIT',
            author: {
                name: 'Perplexity Inc',
                email: 'support@perplexity.ai',
                url: 'https://www.perplexity.ai/',
            },
            homepage: 'https://www.perplexity.ai/',
            icon: 'icon.png',
            tools: [
                {
                    name: 'list_contacts',
                    description: 'List contacts. When query is provided, search for contacts by name. Use it first to get a handle id, phone numbers, or emails. This tool is more preferred to be used first than "list_chats" tool. If this tool returns empty results, try to use "list_chats" tool to find a contact.',
                },
                {
                    name: 'list_chats',
                    description: 'List chats from Messages. When query is provided, search for chats by phone number (preferrable) or chat name (if phone number is not available).',
                },
                {
                    name: 'create_chat',
                    description: 'Create a new chat with a specific contact',
                },
                {
                    name: 'read_chat',
                    description: 'Read Messages from a specific chat',
                },
                {
                    name: 'send_imessage',
                    description: 'Send a Message to specific chat',
                },
            ],
            server: {
                type: 'node',
                entry_point: 'server/index.js',
                mcp_config: {
                    command: 'node',
                    args: ['${__dirname}/server/index.js'],
                    env: {
                        HOME: '${HOME}',
                    },
                },
            },
            compatibility: {
                comet: '>=139.0.0',
                platforms: ['darwin'],
                runtimes: {
                    node: '>=22.0.0',
                },
                permissions: {
                    full_disk_access: true,
                    contacts: {
                        for_tools: ['list_contacts'],
                    },
                },
            },
        },
    },
];
export const useCometAvailableDxts = () => {
    const cometState = useCometState();
    const currentPlatform = useMemo(() => {
        if (!cometState.platformInfo)
            return undefined;
        const { isMac, isWindows, isLinux } = cometState.platformInfo;
        if (isMac)
            return 'darwin';
        if (isWindows)
            return 'win32';
        if (isLinux)
            return 'linux';
        return undefined;
    }, [cometState.platformInfo]);
    return useMemo(() => currentPlatform
        ? getAvailableDxts().filter((dxt) => {
            if (!dxt.manifest.compatibility?.platforms) {
                return true;
            }
            return (currentPlatform && dxt.manifest.compatibility.platforms.includes(currentPlatform));
        })
        : EMPTY_ARRAY, [currentPlatform]);
};
export const findIconUrlForServer = (dxts, server) => {
    return server.dxt_name ? dxts?.find((dxt) => dxt.id === server.dxt_name)?.icon_url : undefined;
};
//# sourceMappingURL=useCometAvailableDxts.js.map